import { Archive, ArchiveRestore } from "lucide-react";
import type { WindowAction } from "./RecordWindow";

/*
 * The actions most windows offer (RecordWindow's More menu), the same everywhere: archive or
 * restore a record. Each says what happens before it's done. `kind` names it ("item", "supplier"); `name`, which one.
 */

const IN_JOBS: Record<string, string> = { item: " and can't be added to jobs", bundle: " and can't be added to jobs" };

/** Archive it (hidden in ServiceM8 and here: a danger) or, archived, restore it. */
export function archiveAction(kind: string, name: string, active: boolean, onChange: (active: boolean) => void): WindowAction {
    if (active) {
        return {
            icon: <Archive className="size-4" />,
            label: "Archive",
            help: "Hides it in ServiceM8 and here. It can be restored.",
            danger: true,
            confirm: {
                title: `Archive this ${kind}?`,
                subject: name,
                message: `It's hidden in ServiceM8 and here${IN_JOBS[kind] ?? ""}. You can restore it any time.`,
                confirmLabel: "Archive",
            },
            run: () => onChange(false),
        };
    }
    return {
        icon: <ArchiveRestore className="size-4" />,
        label: "Restore",
        help: "Shows it in ServiceM8 and here again.",
        confirm: { title: `Restore this ${kind}?`, subject: name, message: "It shows in ServiceM8 and here again.", confirmLabel: "Restore" },
        run: () => onChange(true),
    };
}

